import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import firmReducer from "./firmSlice"; // Import your firmReducer
import clientReducer from "./clientSlice";
import clientDataReducer from "./clientDataSlice";
import attorneyReducer from "./attorneySlice";
import attorneyDataReducer from "./attorneyDataSlice";
import attorneyOnboardingReducer from "./attorneyOnboardingSlice";

// Persist configuration for lawyerData

const attorneyDataPersistConfig = {
  key: "attorneyData",
  storage, // Use localStorage
};

// Persist configuration for firmReducer
const firmPersistConfig = {
  key: "firm",
  storage,
};

const clientDataPersistConfig = {
  key: "clientData",
  storage,
};

// Persist configuration for attorneyOnboarding
const attorneyOnboardingPersistConfig = {
  key: "attorneyOnboarding",
  storage,
};

// Wrap reducers with persistReducer

const persistedAttorneyDataReducer = persistReducer(
  attorneyDataPersistConfig,
  attorneyDataReducer
);

const persistedClientDataReducer = persistReducer(
  clientDataPersistConfig,
  clientDataReducer
);

const persistedFirmReducer = persistReducer(firmPersistConfig, firmReducer);

const persistedAttorneyOnboardingReducer = persistReducer(
  attorneyOnboardingPersistConfig,
  attorneyOnboardingReducer
);

// Configure store
const store = configureStore({
  reducer: {
    attorney: attorneyReducer,
    client: clientReducer,
    firm: persistedFirmReducer, // Persisted
    clientData: persistedClientDataReducer,
    attorneyData: persistedAttorneyDataReducer,
    attorneyOnboarding: persistedAttorneyOnboardingReducer, // Now persisted
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Avoid warnings for non-serializable data
    }),
});

// Persistor for store
export const persistor = persistStore(store);
export default store;
